import { ChangeEvent } from "react";
import { FormGroup } from "react-bootstrap";
import { CSSProperties } from "styled-components";

import InputTextStyles from "../styles/components/InputTextStyles";

interface InputTextProps {
    label?: string;
    value: string;
    placeholder?: string;
    onChange?: (
        event: ChangeEvent<{
            value: unknown;
        }>
    ) => void;
    style?: CSSProperties;
    disabled?: boolean;
    floatLabel?: boolean;
}

function InputText({
    label,
    placeholder,
    value,
    onChange,
    style,
    disabled = false,
    floatLabel = false,
}: InputTextProps) {
    const { StyledFormControl, StyledLabel, StyledFloatingLabel } =
        InputTextStyles;

    const labelDefault = <StyledLabel>{label}</StyledLabel>;

    const inputTextDefault = (
        <StyledFormControl
            type="text"
            style={style}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
        />
    );

    const inputTextFloat = (
        <StyledFloatingLabel
            controlId="floatingInput"
            label={label}
            className="mb-4"
        >
            <StyledFormControl
                type="text"
                size="sm"
                // style={{
                //     fontSize: "14px",
                //     height: "48px",
                //     paddingBotton: "10px",
                // }}
                value={value}
                onChange={onChange}
                disabled={disabled}
            />
        </StyledFloatingLabel>
    );

    return (
        <FormGroup controlId="exampleForm.ControlTextarea1">
            {label && !floatLabel ? labelDefault : null}
            {!floatLabel ? inputTextDefault : null}
            {label && floatLabel ? inputTextFloat : null}
        </FormGroup>
    );
}

export default InputText;
